import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function CatalogFloatingCart({
  cartCount,
  standard,
  premium,
  pl,
  branding,
  accent,
  onCheckoutNavigate,
}) {
  const { t } = useTranslation();
  if (cartCount <= 0) return null;

  return (
    <Button
      size="lg"
      className={cn('fixed right-6 rounded-full h-16 px-6 z-50 bottom-6', standard && 'shadow-lg')}
      style={
        premium
          ? {
              backgroundColor: pl ? '#FFFFFF' : branding.card_background_color,
              borderColor: accent,
              borderWidth: 2,
              color: branding.text_color,
              boxShadow: `0 8px 28px -8px ${accent}50`,
            }
          : { backgroundColor: accent }
      }
      onClick={onCheckoutNavigate}
    >
      <ShoppingCart className="w-5 h-5 mr-2" style={{ color: accent }} />
      {t('catalog.viewCart', { count: cartCount })}
    </Button>
  );
}
